// @ts-nocheck
if (!customElements.get('size-options-sorting')) {
  class SizeOptionsSorting extends HTMLElement {
    constructor() {
      super();
      this.variantOptionsSortingChangedUnsubscriber = undefined;
      this.variantOptionsSorting = undefined;
      // @ts-ignore
      this.desiredOrder = [];
      // @ts-ignore
      this.accessToken = atob(this.dataset.sectionId?.replace('section-id-',''));
    }

    async connectedCallback() {
      this.onVariantOptionsSortingChangedUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantOptionsSortingChanged,
          this._applySortingWithCSSOrder.bind(this)
      );
      const query = `{
        product(handle: "${this.dataset.productHandle}") {
          metafield(namespace: "custom", key: "variant_size_option_sorting") {
            references(first: 250) {
              nodes {
                ... on Metaobject {
                  fields {
                    value
                  }
                }
              }
            }
          }
        }
      }`;

      try {
        const response = await fetch('/api/2025-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.accessToken,
          },
          body: JSON.stringify({ query }),
        });

        const results = await response.json();
        const metaobjects = results?.data?.product?.metafield?.references?.nodes || [];
        // Build desired order array
        this.desiredOrder = metaobjects.map((metaobject) => metaobject.fields[0]?.value).filter(Boolean);
      } catch (error) {
        console.error('Error fetching metaobjects:', error);
      }

      this._applySortingWithCSSOrder();
    }

    _applySortingWithCSSOrder(event = {}) {
      const container = document.querySelector('.variant-option[data-option-handle="size"]');
      if (!container) return;

      // Apply label order using desiredOrder
      const applyLabelOrder = () => {
        const labels = container.querySelectorAll('label');
        let index = 0;
        for (const order of this.desiredOrder) {
          const label = Array.from(labels).find(l => l.innerText.trim() === order.trim());
          if (label) {
            label.style.order = index;
            label.dataset.orderIndex = index;
            index++;
          }
        }
      };

      // Select lowest index input
      const selectLowestInput = () => {
        const inputs = container.querySelectorAll('input[type=radio]:not([data-option-available="false"]):not([aria-disabled="true"])');
        let lowestIndex = Infinity;
        let lowestInput = null;
        let allReady = true;

        Array.from(inputs).forEach(input => {
          const label = input.closest('label');
          if (!label || label.dataset.orderIndex === undefined) {
            allReady = false;
            return;
          }

          const idx = parseInt(label.dataset.orderIndex, 10);
          if (isNaN(idx)) {
            allReady = false;
            return;
          }
          if (idx < lowestIndex) {
            lowestIndex = idx;
            lowestInput = input;
          }
        });
        if (allReady && lowestInput) {
          lowestInput.click();         
        }
      };

      // Observe for dynamic additions and apply sorting once ready
      const observer = new MutationObserver(() => {
        applyLabelOrder();
        requestAnimationFrame(selectLowestInput);
      });

      observer.observe(container, { childList: true, subtree: true });

      // Initial run (in case already loaded)
      applyLabelOrder();
      requestAnimationFrame(selectLowestInput);
    }

  }

  customElements.define('variant-options-sorting', SizeOptionsSorting);
}